/**
 * FikoTakvim Dialog — Üretim Takvimi / Termin Planı UI
 * İş listesi + kapasite → toplam süre, iş günü, teslim tarihi.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TakvimIs, takvimHesapla, isGunuEkle, TakvimSonuc } from './FikoTakvim';

@Component({
  selector: 'fikoyt-takvim',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="tv">
    <div class="tv-baslik">İş Listesi <button class="tv-mini" (click)="ekle()">＋</button></div>
    <div class="tv-th"><span>İş / Parça</span><span>Adet</span><span>Birim dk</span><span></span></div>
    @for (i of isler; track $index) {
      <div class="tv-tr">
        <input [(ngModel)]="i.ad" class="ad">
        <input type="number" [(ngModel)]="i.adet" (ngModelChange)="hesapla()" min="0">
        <input type="number" [(ngModel)]="i.birimDk" (ngModelChange)="hesapla()" min="0" step="0.5">
        <button class="tv-sil" (click)="sil($index)">✕</button>
      </div>
    }

    <div class="tv-kap">
      <div class="tv-in"><label>Tezgâh</label><input type="number" [(ngModel)]="tezgah" (ngModelChange)="hesapla()" min="1"></div>
      <div class="tv-in"><label>Vardiya s/gün</label><input type="number" [(ngModel)]="vardiya" (ngModelChange)="hesapla()" min="1" max="24"></div>
      <div class="tv-in"><label>Verim %</label><input type="number" [(ngModel)]="verim" (ngModelChange)="hesapla()" min="1" max="100"></div>
      <div class="tv-in"><label>Başlangıç</label><input type="date" [(ngModel)]="baslangic" (ngModelChange)="hesapla()"></div>
    </div>

    @if (sonuc) {
      <div class="tv-sonuc">
        <div class="tv-r"><span>Toplam işlem</span><b>{{ f(sonuc.toplamSaat,1) }} saat</b></div>
        <div class="tv-r"><span>Günlük kapasite</span><b>{{ f(sonuc.gunlukKapasiteSaat,1) }} saat/gün</b></div>
        <div class="tv-r vurgu"><span>Süre</span><b>{{ sonuc.isGunu }} iş günü</b></div>
        @if (teslim) { <div class="tv-r teslim"><span>Tahmini teslim</span><b>{{ teslim }}</b></div> }
      </div>
    }
  </div>
  `,
  styles: [`
    .tv { padding:10px; min-width:300px; max-width:340px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .tv-baslik { display:flex; justify-content:space-between; align-items:center; color:#5fd9f5; font-weight:600; margin-bottom:4px; }
    .tv-mini { background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:2px 8px; font-size:10px; cursor:pointer; }
    .tv-th, .tv-tr { display:grid; grid-template-columns:1.5fr 50px 56px 20px; gap:4px; align-items:center; margin-bottom:3px; }
    .tv-th { color:#7fc6dd; font-size:9px; }
    .tv-tr input, .tv-in input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; width:100%; }
    .tv-tr input.ad { text-align:left; }
    .tv-sil { background:rgba(120,40,40,.6); border:1px solid rgba(255,100,100,.4); color:#ff9a9a; border-radius:4px; cursor:pointer; }
    .tv-kap { display:grid; grid-template-columns:1fr 1fr; gap:6px; margin-top:8px; }
    .tv-in { display:flex; flex-direction:column; gap:2px; }
    .tv-in label { font-size:9px; color:#5fd9f5; }
    .tv-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .tv-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .tv-r span { color:#9fe8f7; }
    .tv-r.vurgu { background:rgba(0,200,120,.16); margin:4px -8px; padding:6px 8px; border:none; } .tv-r.vurgu b { color:#7dffc0; font-size:14px; }
    .tv-r.teslim { background:rgba(255,180,0,.14); margin:2px -8px -2px; padding:6px 8px; border:none; } .tv-r.teslim b { color:#ffd76a; font-size:13px; }
  `]
})
export class FikoTakvimComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  isler: TakvimIs[] = [
    { ad: 'Frezeleme', adet: 50, birimDk: 12 },
    { ad: 'Delme', adet: 50, birimDk: 4 },
    { ad: 'Tesviye', adet: 50, birimDk: 3 },
  ];
  tezgah = 2; vardiya = 8; verim = 75; baslangic = '';
  sonuc: TakvimSonuc | null = null;
  teslim = '';

  constructor(private cd: ChangeDetectorRef) { this.sonuc = this.hesaplaInt(); this.teslimHesapla(); }

  private hesaplaInt(): TakvimSonuc {
    return takvimHesapla({ isler: this.isler, tezgahSayisi: this.tezgah, vardiyaSaat: this.vardiya, verimYuzde: this.verim });
  }
  hesapla(): void { this.sonuc = this.hesaplaInt(); this.teslimHesapla(); this.cd.detectChanges(); }

  private teslimHesapla(): void {
    this.teslim = '';
    if (!this.baslangic || !this.sonuc) return;
    const b = new Date(this.baslangic + 'T00:00:00');
    if (isNaN(b.getTime())) return;
    const t = isGunuEkle(b, this.sonuc.isGunu);
    this.teslim = t.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric', weekday: 'short' });
  }

  ekle(): void { this.isler.push({ ad: 'Operasyon', adet: 1, birimDk: 5 }); this.hesapla(); }
  sil(i: number): void { this.isler.splice(i, 1); this.hesapla(); }

  f(v: number, d = 1): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
